import styled from 'styled-components';
import { Typography } from '@mui/material';
import { fontSize, fontWeight } from '@elementary/common-ui/style/utils';
import ContentWithLabel, { Variant } from './ContentWithLabel';

const ValueWrapper = styled(Typography)<{
  $variant: Variant;
  $valueColor?: string;
}>`
  font-size: ${({ $variant }) =>
    $variant === 'big' ? '32px' : fontSize('xxxl')};
  font-weight: ${fontWeight('medium')};
  color: ${({ $valueColor, theme }) =>
    $valueColor ?? theme.palette.content.primary};
`;

type Props = {
  title?: string;
  variant?: Variant;
  value: string;
  valueColor?: string;
  titleLink?: string;
};

const TextWithLabel = ({
  title = '',
  variant = 'regular',
  value,
  valueColor,
  titleLink,
}: Props) => (
  <ContentWithLabel title={title} link={titleLink}>
    <ValueWrapper $variant={variant} $valueColor={valueColor}>
      {value}
    </ValueWrapper>
  </ContentWithLabel>
);
export default TextWithLabel;
